import axios from 'axios';
import { request } from './http'

// 发送验证码
export const sendCode = params => {
    return request(`/official/open/user/sendCode`, params).then(res => res);
};

// 修改手机号
export const updatePhone = params => {
    return request(`/official/private/user/update/phone`, params).then(res => res);
};

// 修改用户信息
export const updateUserInfo = params => {
    return request(`/official/private/user/update`, params).then(res => res);
};

// 绑定设备
export const bindEquipment = params => {
    return request(`/official/private/user/bind/equipment`, params).then(res => res);
};

// 用户设备列表
export const userEquipmentList = params => {
    return request(`/official/private/user/list/equipment`, params).then(res => res);
};

// 用户维保记录
export const userMaintenanceList = params => {
    return request(`/official/private/user/list/maintenance`, params).then(res => res);
};

// 登录
export const login = params => {
    return request(`/official/open/user/login`, params).then(res => res);
    // return axios.post(`apis/official/open/user/login`, params).then(res => res);
};

// 登出
export const logout = params => {
    return request(`/official/open/user/logout`, params).then(res => res);
};


// 申请参观工厂
export const visit = params => {
    return request(`/official/open/user/visit`, params).then(res => res);
};

// 获取新闻列表
export const newsList = params => {
    return request(`/open/web/news/list`, params).then(res => res);
};

// 获取新闻详情
export const newsDetail = params => {
    return request(`/open/web/news/list/desc`, params).then(res => res);
};

// 验证城市合伙人
export const cityPartner = params => {
    return request(`/official/open/cityPartner/check`, params).then(res => res);
};

// club评论列表
export const clubComment = params => {
    return request(`/official/open/comment/list`, params).then(res => res);
};

// club发表评论
export const submitComment = params => {
    return request(`/official/private/comment/post`, params).then(res => res);
};

// cityPartners采购加盟申请
export const submitJoin = params => {
    return request(`/open/join/info/add`, params).then(res => res);
};

// cityPartners采购加盟已申请列表
export const joinList = params => {
    return request(`/open/join/info/list`, params).then(res => res);
};

// 新闻列表
export const newNewsList = params => {
    return request(`/open/web/news/getNewList`, params).then(res => res);
};

// 生成小程序短链
export const getSchemeUrl = params => {
    return request(`/open/link/get/schemeByShortId`, params).then(res => res);
};

// 保存实名信息
export const saveIdInfo = params => {
    return request(`/private/yyx/update/realNameInfo`, params).then(res => res);
};
